// Vendor imports
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AuthSection')

class AuthSection extends React.PureComponent {
  constructor(props) {
    super(props)

    this.renderAuthLink = this.renderAuthLink.bind(this)
    this.onAppDownloadClick = this.onAppDownloadClick.bind(this)
    this.onSocialProviderClick = this.onSocialProviderClick.bind(this)
  }

  // Event handler methods

  onAppDownloadClick() {
    this.props.onAppDownload(this.props.mobilePlatform)
  }

  onSocialProviderClick(event) {
    const { provider } = event.currentTarget.dataset
    this.props.onSocialProviderAuth(provider)
  }

  // Render methods

  renderPrimary() {
    if (this.props.mobilePlatform) {
      return this.renderMobilePrimary()
    }
    return this.renderDesktopPrimary()
  }

  renderDesktopPrimary() {
    const providerId = 'google'
    const providerName = 'Google'
    return (
      tag(CapsuleButton, {
        className: bem.element('primary', {
          desktop: true,
          provider: providerId
        }),
        title: `Sign in with ${providerName}`,
        'data-provider': providerId,
        onClick: this.onSocialProviderClick
      },
        tag(Icon, {
          className: bem.element('primary-icon'),
          id: providerId
        }),
        `Sign in with ${providerName}`
      )
    )
  }

  renderMobilePrimary() {
    const { downloadHref, mobilePlatform  } = this.props
    let iconId
    if (mobilePlatform === 'android') {
      iconId = 'google-play'
    } else if (mobilePlatform === 'ios') {
      iconId = 'apple'
    }
    return (
      tag(CapsuleButton, {
        className: bem.element('primary', {
          mobile: true,
          platform: mobilePlatform
        }),
        href: downloadHref,
        title: 'Download the Mix app',
        onClick: this.onAppDownloadClick
      },
        tag(Icon, {
          className: bem.element('primary-icon'),
          id: iconId
        }),
        'Download the app'
      )
    )
  }

  renderSecondary() {
    const { mobilePlatform, socialProviders } = this.props
    return (
      tag('div', {
        className: bem.element('secondary')
      },
        tag('span', {
          className: bem.element('secondary-heading')
        },
          (mobilePlatform ? 'Or sign in with:' : 'Or use:')
        ),
        tag('span', {
          className: bem.element('secondary-actions')
        },
          socialProviders.map(this.renderAuthLink)
        )
      )
    )
  }

  renderAuthLink(provider) {
    // Don't show Google on Desktop here because it is the Primary button
    if (!this.props.mobilePlatform && provider.id === 'google') {
      return null
    }
    return (
      tag('a', {
        key: provider.id,
        className: bem.element('auth-link', {
          provider: provider.id
        }),
        title: `Sign in with ${provider.name}`,
        'data-provider': provider.id,
        onClick: this.onSocialProviderClick
      },
        provider.name
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderPrimary(),
        this.renderSecondary()
      )
    )
  }
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  AuthSection.propTypes = {
    // Values
    className: PropTypes.string,
    downloadHref: PropTypes.string,
    mobilePlatform: PropTypes.oneOf(['android', 'ios']),
    socialProviders: PropTypes.arrayOf(PropTypes.object).isRequired,
    // Callbacks
    onAppDownload: PropTypes.func,
    onSocialProviderAuth: PropTypes.func
  }
}

module.exports = AuthSection
